import { ScrollArea } from 'ui/scrollArea';
import { Toolbar } from './Toolbar/Toolbar';
import { Container, Content, InnerContainer } from './Dashboard.styled';
import { GoalsDashboard } from './GoalsDashboard';
import { HealthDashboard } from './HealthDashboard';

export const Dashboard = () => {
  return (
    <Container minHeight="unset" data-test="dashboard-container">
      <Toolbar />
      <InnerContainer data-test="dashboard-inner-container">
        <ScrollArea>
          <Content>
            <HealthDashboard />
            <GoalsDashboard />
          </Content>
        </ScrollArea>
      </InnerContainer>
    </Container>
  );
};
